module.exports = __webpack_public_path__ + "media/images/flags/gt-a208122c79ed1281ce1a7d82a7c56fe4.svg";